import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import MultiSelect from "../../../../Components/Common/MultiSelect";
import EditDialog from "../../../../Components/Common/EditDialog";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { useUser } from "../../../../context/AuthContext";
import { facilityEquipmentIds } from "../../../../utils/facilityEquipmentIds";

function AddConsumptionFacility({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  SelectedData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});

  const initialState = {
    vendor: SelectedData?.vendor?._id || "",
    unitOfConsumption: SelectedData?.unitOfConsumption || "",
    previousMeterReading: SelectedData?.previousMeterReading || "",
    currentMeterReading: SelectedData?.currentMeterReading || "",
    equipment: facilityEquipmentIds(SelectedData),
    consumptionPeriod: SelectedData?.consumptionPeriod,
    reasonForDeviation: SelectedData?.reasonForDeviation || "",
    remarks: SelectedData?.remarks || "",
    documents: SelectedData?.documents || [],
    multiplicationFactor: SelectedData?.multiplicationFactor || "",
    editRemarkReason: SelectedData?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [editDialog, setEditDialog] = useState(false);

  useEffect(() => {
    let difference =
      parseInt(formData.currentMeterReading) -
      parseInt(formData.previousMeterReading);
    if (difference < 0) {
      setErrors({
        ...errors,
        currentMeterReading:
          "Current Meter Reading must be greater than Previous Meter Reading",
      });
    }
  }, [formData.currentMeterReading, formData.previousMeterReading]);

  useEffect(() => {
    if (id && SelectedData) {
      setFormData({
        ...initialState,
      });
      setFormData2({
        ...initialState,
      });
      setUploadedFiles(SelectedData?.documents || []);
    } else {
      setFormData(initialState);
      setFormData2(initialState); // Reset formData2 when creating new data
      setUploadedFiles(SelectedData !== null ? SelectedData?.documents : []);
    }
  }, [SelectedData, id]);

  useEffect(() => {
    let unitCount =
      formData.currentMeterReading - formData.previousMeterReading;

    if (unitCount > 0) {
      setFormData((prevData) => ({
        ...prevData,
        unitOfConsumption: unitCount * formData?.multiplicationFactor,
      }));
    }
  }, [
    formData.previousMeterReading,
    formData.currentMeterReading,
    formData.multiplicationFactor, // Include multiplicationFactor here
  ]);

  const handleChange = (e) => {
    // For native events, e.target contains the name and value
    if (e.target) {
      const { name, value } = e.target;
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    } else {
      const { name, value } = e;
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(formData.documents || SelectedData?.documents || []);
  };

  const handleClose = () => {
    const isFormDataUnchanged =
      JSON.stringify(formData) === JSON.stringify(formData2);
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree(); // Close the dialog if there are no unsaved changes
    } else {
      setEditDialog(true); // Show confirmation dialog if there are unsaved changes
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (!validateNumber(month)) newErrors["month"] = "Month is required";
        if (!validateNumber(year)) newErrors["year"] = "Year is required";
        return;
      }

      // Check for calorificValue separately
      if (input.fieldName === "calorificValue") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        if (!validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }

      // if (input.fieldName === "equipment") {
      //   if (!value || value.length === 0) {
      //     newErrors[input.fieldName] =
      //       "At least one equipment must be selected.";
      //   }
      // }

      if (input.fieldName === "quantityConsumed") {
        const Value = formData[input.fieldName]?.value || ""; // Ensure it's a string

        if (!validateNumber(Value)) {
          newErrors[input.fieldName] = numberError;
        }

        return; // Ensure to return after handling errors for calorificValue
      }

      // Skip validation for hours and industrialEquipment if not in Individual mode
      if (
        formData.typeOfEntry !== "Individual" &&
        (input.fieldName === "hours" ||
          input.fieldName === "industrialEquipment")
      ) {
        return; // Skip validation for these fields
      }

      // Validation for numeric inputs
      if (input.type === "number" && input.required) {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      const previousReading = parseFloat(formData.previousMeterReading);
      const currentReading = parseFloat(formData.currentMeterReading);

      const isPrevEmpty = formData.previousMeterReading === "";
      const isCurrEmpty = formData.currentMeterReading === "";

      if (isPrevEmpty && isCurrEmpty) {
        newErrors.currentMeterReading = "Please enter a valid numeric value.";
      } else if (!isNaN(currentReading) && !isNaN(previousReading)) {
        if (currentReading <= previousReading) {
          newErrors.currentMeterReading =
            "Current Meter Reading must be greater than Previous Meter Reading";
        }
      } else {
        newErrors.currentMeterReading = "Please enter a valid numeric value.";
      }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        input.type !== "multiselect" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
    };
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values

    // Conditionally delete fields if typeOfEntry is not "Individual"
    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hours;
      delete dataToSend.industrialEquipment;
    }
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }
    // Remove fields that have empty values
    Object.keys(dataToSend).forEach((key) => {
      const value = dataToSend[key];
      if (typeof value === "object" && value !== null) {
        Object.keys(value).forEach((nestedKey) => {
          const nestedValue = value[nestedKey];
          if (
            nestedValue === "" ||
            nestedValue === null ||
            nestedValue === undefined
          ) {
            delete value[nestedKey];
          }
        });

        if (Object.keys(value).length === 0) {
          delete dataToSend[key];
        }
      } else if (value === "" || value === null || value === undefined) {
        if (key !== "remarks") {
          delete dataToSend[key];
        }
      }
    });

    const url = SelectedData?._id
      ? `${updateUrl}?Id=${SelectedData?._id}`
      : `${addUrl}`;

    const method = SelectedData?._id ? put : post;
    try {
      const res = await method(url, dataToSend);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
      setFormData2({ ...formData });
      setUploadedFiles(formData.documents || []);
      handleExitAgree();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      }
    }
  };

  const renderInputField = (el) => {
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }

    if (el.type === "multiselect") {
      return (
        <MultiSelect
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          label="Choose Options"
          onChange={handleChange}
          errors={errors[el.fieldName]}
          url={el.url}
        />
      );
    }

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }
    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
            }}
          />
        </Box>
      );
    }

    if (el.fieldName === "reasonForDeviation")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        disabled={el.fieldName === "unitOfConsumption"}
        adornmentText={el.adornmentText || ""} // Pass error prop
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem", maxWidth: "100%" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {SelectedData?._id
            ? `Edit Consumption by Facility`
            : `Add Consumption by Facility`}
          {/* AddData */}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null;
          }
          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      {list()}
    </Drawer>
  );
}

export default AddConsumptionFacility;
